import { getRefinanceParameterizedQuoteEndpoint } from "./getRefinanceParameterizedQuoteEndpoint";
import { getPurchaseOrBuildParameterizedQuoteEndpoint } from "./getPurchaseOrBuildParameterizedQuoteEndpoint";

export const getEndpointBuilder = (lookingTo) => {
  if (lookingTo === "Refinance" || lookingTo === "RefinanceAndCashOut") {
    return getRefinanceParameterizedQuoteEndpoint;
  }
  return getPurchaseOrBuildParameterizedQuoteEndpoint;
};
